import { LocationInfo } from 'components/_controls/AoiSearch/models';

export function setVtLocations(vaccineLocationInfoById: Record<number, LocationInfo>) {
  localStorage.setItem(
    'rt-added-location-ids',
    JSON.stringify(Object.values(vaccineLocationInfoById).map(location => location.id))
  );
}

export function getVtLocationIds(): number[] {
  const idsStr = localStorage.getItem('rt-added-location-ids');
  if (idsStr) return JSON.parse(idsStr) as number[];

  // TODO: 8ac18686: this block is for backwards compatibility of rt-added-locations localStorage key
  const storedLocationsStr = localStorage.getItem('rt-added-locations');
  return storedLocationsStr
    ? (JSON.parse(storedLocationsStr) as LocationInfo[]).map(x => x.id)
    : [];
}
